// Libs
import React from 'react';

export default ({ fill = 'white', fillOpacity = '0.80' }) => (
	<svg
		width='24'
		height='24'
		viewBox='0 0 24 24'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M14.1819 9.81819V4H9.81822V9.81819H4V14.1818H9.81822V20H14.1819V14.1818H20V9.81819H14.1819Z'
			fill={fill}
			fillOpacity={fillOpacity}
		/>
	</svg>
);
